import { render, staticRenderFns } from "./divider.vue?vue&type=template&id=8cfad4ac"
import script from "./divider.vue?vue&type=script&lang=js"
export * from "./divider.vue?vue&type=script&lang=js"
import style0 from "./divider.vue?vue&type=style&index=0&id=8cfad4ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports